import queryString from "query-string";
import { isEmpty } from "lodash";

export function getQeuryParams(data: object | undefined) {
  const result = data
    ? `?${queryString.stringify(
      { ...data },
      { skipEmptyString: true, skipNull: true }
    )}`
    : "";
  return result;
}

export function areQueryParamsEmpty(
  params: object | undefined,
  ignoreParams?: string[],
  treatFalseAsValue?: boolean
) {
  if (isEmpty(params)) {
    return true;
  }
  for (const [key, value] of Object.entries(params)) {
    if (ignoreParams === undefined || !ignoreParams.includes(key)) {
      const hasValue = treatFalseAsValue
        ? (value !== null && value !== undefined && value !== "")
        : value;

      if (hasValue) {
        return false;
      }
    }
  }
  return true;
}
